'use client';

import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useAuth } from '../contexts/AuthContext';
import { useSelector } from 'react-redux';
import { toast } from 'sonner';
import LoadingSpinner from '../components/LoadingSpinner';

const Login = () => {
	const { loginInstitution } = useAuth();
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	// Redux state for logging
	const authState = useSelector((state) => state.auth);
	const userData = useSelector((state) => state.user);

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm();

	const onSubmit = async (data) => {
		setLoading(true);
		try {
			const response = await loginInstitution(
				data.clientId,
				data.clientSecret,
			);
			console.log('✅ Login Response:', response);

			// Log Redux store state after login
			console.log('🏪 Redux Auth State:', authState);
			console.log('👤 Redux User Data:', userData);
			console.log('🔑 Is Authenticated:', authState.isAuthenticated);
			console.log('🏢 Institution ID:', authState.institutionId);
			console.log(
				'🎫 Access Token:',
				authState.accessToken ? '***TOKEN_EXISTS***' : 'NO_TOKEN',
			);
			navigate('/dashboard');
		} catch (error) {
			console.error('❌ LOGIN PAGE: Login error:', error);
			const message =
				error.response?.data?.message ||
				error.message ||
				'Login failed';
			toast.error(message);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className='min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8'>
			<div className='max-w-md w-full space-y-8'>
				<div className='text-center'>
					<div className='mx-auto h-16 w-16 bg-primary-600 rounded-xl flex items-center justify-center shadow-lg'>
						<span className='text-white font-bold text-2xl'>K</span>
					</div>
					<h2 className='mt-6 text-center text-3xl font-extrabold text-gray-900'>
						Sign in to Kaino
					</h2>
					<p className='mt-2 text-center text-sm text-gray-600'>
						Or{' '}
						<Link
							to='/register'
							className='font-medium text-primary-600 hover:text-primary-500 transition-colors'>
							create a new account
						</Link>
					</p>
				</div>

				<form
					className='mt-8 space-y-6'
					onSubmit={handleSubmit(onSubmit)}>
					<div className='space-y-4'>
						<div>
							<label
								htmlFor='clientId'
								className='block text-sm font-medium text-gray-700'>
								Client ID
							</label>
							<input
								{...register('clientId', {
									required: 'Client ID is required',
								})}
								type='text'
								className='input-field mt-1'
								placeholder='Enter your client ID'
							/>
							{errors.clientId && (
								<p className='mt-1 text-sm text-red-600'>
									{errors.clientId.message}
								</p>
							)}
						</div>

						<div>
							<label
								htmlFor='clientSecret'
								className='block text-sm font-medium text-gray-700'>
								Client Secret
							</label>
							<input
								{...register('clientSecret', {
									required: 'Client Secret is required',
								})}
								type='password'
								className='input-field mt-1'
								placeholder='Enter your client secret'
							/>
							{errors.clientSecret && (
								<p className='mt-1 text-sm text-red-600'>
									{errors.clientSecret.message}
								</p>
							)}
						</div>
					</div>

					<div>
						<button
							type='submit'
							disabled={loading}
							className='btn-primary w-full'>
							{loading ? (
								<>
									<LoadingSpinner
										size='sm'
										className='mr-2'
									/>
									Signing in...
								</>
							) : (
								'Sign in'
							)}
						</button>
					</div>

					<div className='text-center'>
						<p className='text-xs text-gray-500'>
							By signing in, you agree to our Terms of Service and
							Privacy Policy
						</p>
					</div>
				</form>
			</div>
		</div>
	);
};

export default Login;
